import { Field } from '../../../common';
import Modal from '../../../common/Modal';
import { useState } from 'react';


interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;

}

function ApproveReviewModal({ isOpen, onClose, onConfirm }: ModalProps) {
  const [manualConfirmMessage, setManualConfirmMessage] = useState('Godkänt manuellt');

  return (
    <Modal isOpen={isOpen} closeModal={onClose} className={''}>
      <h4>Manuellt godkännande</h4>
      <Field type="textarea" name="reason" title="" placeholder="Skriv anledning..." value={manualConfirmMessage} onChange={(e) => setManualConfirmMessage(e['reason'])} />
      <button className="xs cancel" onClick={onClose}>Avbryt</button>
      <button className="xs primary" onClick={() => onConfirm(manualConfirmMessage)}>Skicka</button>
    </Modal>
  )
}

export default ApproveReviewModal;
